import React, { FC } from 'react';
import { useEffect } from 'react';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';
import { isSubContractedWorkOrder } from '../../utils/WorkOrderUtils';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { changeClientView } from '../../actions/client_view_actions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

const SubcontractorInvoicesLandingPage: FC<any> = ({
	match,
	history,
	workOrdersFetching,
	updateClientView,
	workOrder,
}): React.ReactElement => {
	const redirectUrl = `/supplier/workOrders/detail/${match.params.id}/invoices`;

	const workOrderId = nullSafeGet(`id`, workOrder);
	useEffect(() => {
		if (workOrderId) {
			if (isSubContractedWorkOrder(workOrder)) {
				updateClientView(false);
			} else {
				updateClientView(true);
			}
			history.replace(`${redirectUrl}`);
		}
	}, [workOrderId, history, redirectUrl, updateClientView, workOrder]);

	return workOrdersFetching ? (
		<Spin indicator={<LoadingOutlined style={{ fontSize: 16, color: '#fff' }} spin />} />
	) : null;
};

const mapStateToProps = (state, ownProps) => ({
	workOrdersFetching: state.work_orders.fetching,
	workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
});

const mapDispatchToProps = (dispatch) => ({
	updateClientView: (isClientView) => dispatch(changeClientView(isClientView)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SubcontractorInvoicesLandingPage)
);
